import React from 'react';
import SupplementQuiz from '../components/supplements/SupplementQuiz';

// SS4 — the public, no-account funnel entry (routed at /quiz). Shareable from the
// YouTube channel: "take the supplement quiz." It runs the same honesty-first
// engine as the logged-in app, works with zero data, and softly invites signing
// up to actually track whether a supplement is doing anything.

const SupplementQuizPage = () => {
  return (
    <div className="min-h-screen bg-surface dark:bg-surface-dark py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto space-y-6">
        <div className="text-center">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white">
            The honest supplement quiz
          </h1>
          <p className="mt-3 text-base sm:text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            Tell us your goals and we’ll give you evidence-graded suggestions — the
            ones worth taking, the ones you can get from food, and the ones to skip.
            No account, no hype.
          </p>
        </div>
        <SupplementQuiz />
      </div>
    </div>
  );
};

export default SupplementQuizPage;
